import { createApiSlice } from "@common";
import { CRUD_CRM_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addCrmStatus",
    method: "post",
    url: CRUD_CRM_STATUS,
    stateKey: "message",
  },
  {
    name: "getCrmStatus",
    method: "get",
    url: CRUD_CRM_STATUS,
    stateKey: "data",
  },
  {
    name: "updateCrmStatus",
    method: "put",
    url: CRUD_CRM_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteCrmStatus",
    method: "delete",
    url: CRUD_CRM_STATUS,
    stateKey: "message",
  },
];
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "crmStatus",
  apiConfig,
  customReducers);
const crmStatusSlice = slice;

export default crmStatusSlice.reducer;

export const {
  addCrmStatus,
  getCrmStatus,
  updateCrmStatus,
  deleteCrmStatus,
} = thunks;

export const { rowSelect } = actions;
